module.exports = __webpack_public_path__ + "media/images/vector-25@2x-aa36fbf16da7d696094e6fa5c92aa1d9.png";